import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import genreList from '@/js/data/genre';
import { areas as areaList } from '@/js/data/area';


export default /*#__PURE__*/_defineComponent({
  __name: 'find-events',
  setup(__props) {

const activeTab = ref<string>();
const activeArea = ref<string>();
const periodLabel = (period: string) => {
  const labelObj = {
    ongoing: '開催中',
    'this-week': '今週',
    'this-weekend': '今週末',
    'this-month': '今月',
    'next-month': '来月以降',
  };
  return labelObj[period] || '';
};
const onClickMenu = (item: string) => {
  activeTab.value = activeTab.value === item ? undefined : item;
};
const onClickArea = (area: string) => {
  activeArea.value = activeArea.value === area ? undefined : area;
};

return { __sfc: true,activeTab, activeArea, periodLabel, onClickMenu, onClickArea, genreList, areaList }
}

})